import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";
export const GET_ACTIVE_USER_LIST_FOR_TASK_GROUP =
  "GET_ACTIVE_USER_LIST_FOR_TASK_GROUP";

export const service = async (data) => {
  const options: object = {
    url: `/Api/TaskGroups/GetActiveUserListForUserGroup`,
    method: "GET",
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_ACTIVE_USER_LIST_FOR_TASK_GROUP, service, mock);
